import { useMutation } from '@tanstack/react-query';
import { generateSignedPdfFile } from './generate_signed_pdf';
import { uploadMedableFile } from './medable_file_upload';
/**
 * Orchestrates generating a signed PDF (with overlays baked in) and uploading
 * it to `ec__final_document` on the signed document in one step.
 */
export function useSignedPdfUpload({ apiClient, accountId, onSuccess, onError }) {
    const mutation = useMutation({
        mutationFn: async ({ pdfBytes, signatures, signedDocId, fileName }) => {
            if (!apiClient) {
                throw new Error('An API client is required to upload signed PDFs.');
            }
            if (!signatures.length) {
                throw new Error('At least one signature overlay is required.');
            }
            const file = await generateSignedPdfFile({ pdfBytes, signatures }, fileName);
            await uploadMedableFile({ apiClient, accountId, signedDocId, file });
        },
        onSuccess,
        onError,
    });
    return {
        uploadSignedPdf: mutation.mutateAsync,
        isUploading: mutation.isPending,
        uploadError: mutation.error,
    };
}
